export enum StatusEnum {
    Pending = "PENDING",
    Win = "WIN",
    Lose = "LOSE",
    Void = "VOID",
    Cancel = "CANCEL",
    Delete = "DELETE"
}